import styled from 'styled-components'

import { Tabbar } from 'common-components'
import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const PADDING = 16

export const AiImageContentContainer = styled.div<{
  $hasSelectedItem?: boolean
}>`
  padding-top: ${({ $hasSelectedItem }) => ($hasSelectedItem ? '24px' : '0')};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  }
`

export const AiImageTabbar = styled(Tabbar)`
  width: calc(100% - ${PADDING * 2}px);
  margin: 0 auto;
`
